var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-popup',{attrs:{"close-on-click-overlay":false},model:{value:(_vm.showError),callback:function ($$v) {_vm.showError=$$v},expression:"showError"}},[_c('div',{staticClass:"error"},[_c('div',{staticClass:"title"},[_vm._v("请求错误")]),_c('div',{staticClass:"content"},[_vm._v(" 请求了错误的链接，如有疑问，请联系群主或管理员。 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }